import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

import { analyticsApi } from '../../api/analytics.js';
import { useAuth } from '../../auth/AuthProvider.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { KpiCard } from '../../components/ui/KpiCard.jsx';
import { Button } from '../../components/ui/Button.jsx';
import { PageHeader } from '../../components/ui/PageHeader.jsx';
import { fmt } from '../../lib/formatters.js';

export function EmployeeHomePage() {
  const { user, hasPermission } = useAuth();
  const name = (user && (user.firstName || user.email)) || '';

  const canStats = hasPermission('analytics:read');
  const stats = useQuery({
    queryKey: ['employee', 'self-stats'],
    enabled: canStats && Boolean(user && user._id),
    queryFn: () => analyticsApi.employeeReport(user._id, { period: '30d' })
  });

  const data = stats.data;

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title={`Ciao ${name}`}
        description="Le tue attività degli ultimi 30 giorni e scorciatoie per il lavoro quotidiano."
      />

      {canStats && (
        <section className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <KpiCard label="Conversazioni AI" loading={stats.isLoading} value={data ? fmt.int(data.conversations) : '-'} sub={data ? `${fmt.int(data.aiCalls)} chiamate` : null} />
          <KpiCard label="Token" loading={stats.isLoading} value={data ? fmt.int(data.totalTokens) : '-'} />
          <KpiCard label="Latenza media" loading={stats.isLoading} value={data ? fmt.durationMs(data.avgLatencyMs) : '-'} />
          <KpiCard label="Prodotti creati" loading={stats.isLoading} value={data ? fmt.int(data.productsCreatedInPeriod) : '-'} sub={data && data.lastInteractionAt ? `Ultima attività ${fmt.dateTime(data.lastInteractionAt)}` : null} />
        </section>
      )}

      <section className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {hasPermission('products:read') && (
          <Card>
            <h2 className="text-base font-semibold text-ink">Inventario</h2>
            <p className="mt-1 text-sm text-ink-muted">Consulta e aggiorna prodotti e scorte del tuo negozio.</p>
            <div className="mt-4">
              <Link to="/employee/inventory">
                <Button variant="secondary">Vai all'inventario</Button>
              </Link>
            </div>
          </Card>
        )}
        {hasPermission('ai:chat') && (
          <Card>
            <h2 className="text-base font-semibold text-ink">Assistente AI</h2>
            <p className="mt-1 text-sm text-ink-muted">Chiedi consigli su prodotti, razze, scorte e procedure interne.</p>
            <div className="mt-4">
              <Link to="/employee/chat">
                <Button>Apri la chat</Button>
              </Link>
            </div>
          </Card>
        )}
        <Card>
          <h2 className="text-base font-semibold text-ink">Account e sicurezza</h2>
          <p className="mt-1 text-sm text-ink-muted">Aggiorna i tuoi dati, la password e l'autenticazione a due fattori.</p>
          <div className="mt-4">
            <Link to="/employee/account">
              <Button variant="ghost">Vai all'account</Button>
            </Link>
          </div>
        </Card>
      </section>
    </div>
  );
}
